<template>
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 my-12">
    <div class="col-span-2">
      <img src="/images/image-web-3-desktop.jpg" class="" />
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8">
        <div>
          <h2 class="text-5xl font-bold mb-2">The Bright Future of Web 3.0?</h2>
        </div>
        <div class="text-gray-700 text-md">
          <div>
            We dive into the next evolution of the web that claims to put the
            power of the platforms back into the hands of the people. But is it
            really fulfilling its promise?
          </div>
          <div class="mt-6">
            <a
            href="#"
            class="text-white bg-[#19193b] hover:bg-[#dc9eac] hover:text-[#19193b] py-2 px-2 mt-6 font-extralight tracking-wide"
            >READ MORE</a
          >
          </div>
        </div>
      </div>
    </div>
    <div class="col-span-1 bg-[#19193b] text-white p-8">
      <!-- Content Sections -->
      <div class="space-y-6">
        <div class="p-2">
          <h2 class="text-5xl text-[#e29c49] font-bold mb-6">News</h2>
        </div>
        <!-- Hydrogen VS Electric Cars -->
        <div class="p-2">
          <h2 class="text-xl font-bold mb-6 hover:text-[#e29c49]  hover:cursor-pointer">Hydrogen VS Electric Cars</h2>
          <p class="text-gray-500 text-sm">
            Will hydrogen-fueled cars ever catch up to EVs?
          </p>
        </div>

        <!-- The Downsides of AI Artistry -->
        <div class="p-2">
          <h2 class="text-xl font-bold mb-6 hover:text-[#e29c49]  hover:cursor-pointer">The Downsides of AI Artistry</h2>
          <p class="text-gray-500 text-sm">
            What are the possible adverse effects of on-demand AI image
            generation?
          </p>
        </div>

        <!-- Is VC Funding Drying Up? -->
        <div class="p-2">
          <h2 class="text-xl font-bold mb-6 hover:text-[#e29c49]  hover:cursor-pointer">Is VC Funding Drying Up?</h2>
          <p class="text-gray-500 text-sm">
            Private funding by VC firms is down 50% YoY. We take a look at what
            that means.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <!-- Reviving Retro PCs -->
      <div class="grid grid-cols-3">
        <div class="col-span-1">
          <img src="/images/image-retro-pcs.jpg" />
        </div>
        <div class="p-1 col-span-2">
        <div class="flex flex-col">
          <span class="text-4xl font-bold text-[#dc9eac] mb-4 mr-4">01</span>
          <h2 class="text-xl font-bold mb-4">Reviving Retro PCs</h2>
          <p class="text-gray-700">What happens when old PCs are given modern upgrades?</p>

        </div>
        </div>
      </div>
      <!-- Top 10 Laptops of 2022 -->
      <div class="grid grid-cols-3">
        <div class="col-span-1">
          <img src="/images/image-top-laptops.jpg" />
        </div>
        <div class="p-1 col-span-2">
        <div class="flex flex-col">
          <span class="text-4xl font-bold text-[#dc9eac] mb-4 mr-4">02</span>
          <h2 class="text-xl font-bold mb-4">Top 10 Laptops of 2022</h2>
          <p class="text-gray-700">Our best picks for various needs and budgets.</p>

        </div>
        </div>
      </div>

      <!-- The Growth of Gaming -->
      <div class="grid grid-cols-3">
        <div class="col-span-1">
          <img src="/images/image-gaming-growth.jpg" />
        </div>
        <div class="p-1 col-span-2">
        <div class="flex flex-col">
          <span class="text-4xl font-bold text-[#dc9eac] mr-4 mb-4">03</span>
          <h2 class="text-xl font-bold mb-4">The Growth of Gaming</h2>
          <p class="text-gray-700">How the pandemic has sparked fresh opportunities.</p>
        </div>
      </div>

      </div>

    </div>
</template>
